import store from '../../index.js'

const state = {
  symbology: {},
}

const getters = {
  getSymbology: state => state.symbology,
}

const mutations = {
  loadSymbologyFromLocalStorage (state, symbology) {
    state.symbology = JSON.parse(symbology)
  },
  saveSymbology (state, payload) {
    const compositeKey = payload.storeKey + (payload.layerKey || payload.layerKey === 0 ? `##${payload.layerKey}` : '')
    const localStoragePropName = `symbology-${store.getters.getViewerName}` + (store.getters.getLoggedInUser?.username ? `-${store.getters.getLoggedInUser.username}` : '')

    if (Object.keys(payload.symbology).length < 1) {
      const tempSymbology = { ...state.symbology }
      delete tempSymbology[compositeKey]
      state.symbology = tempSymbology
      localStorage.setItem(localStoragePropName, JSON.stringify(state.symbology))
      return
    }
    const symbologyTemp = {}

    for (const key in payload.symbology) {
      symbologyTemp[key] = {
        isActive: payload.symbology[key].isActive,
        type: payload.symbology[key].type,
        renderer: payload.symbology[key].renderer.toJSON(),
      }
    }
    state.symbology = {
      ...state.symbology,
      [compositeKey]: symbologyTemp,
    }
    localStorage.setItem(localStoragePropName, JSON.stringify(state.symbology))
  },
}

const actions = {
  saveSymbology ({ commit }, payload) {
    commit('saveSymbology', payload)
  },
  loadSymbologyFromLocalStorage ({ commit }, payload) {
    commit('loadSymbologyFromLocalStorage', payload)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
